<main :is="page" :lang="getLang()"></main>
